"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/blogSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection4612sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Healthy Living" | "Nutrition Tips" | "Weight Management" */
    a0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-img-7.jpg" | "/Templates/Doccure/img/blog/blog-img-8.jpg" | "/Templates/Doccure/img/blog/blog-img-9.jpg" */
    src: string;
    /** Detected variants: "10 Healthy Eating Habits for Better Living" | "Essential Nutrients Your Body Needs Daily" | "Weight Loss Foods That Actually Work" */
    a0A0Text: ReactNode;
    /** Detected variants: "Discover simple daily habits that improve nutrition, boost energy, and support long-term wellness." | "Learn about vitamins, minerals, proteins, and on the other nutrients required for optimal health." | "Explore nutrient-rich foods that help manage is the more weight while keeping you satisfied." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/users/user-sm-1.jpg" | "/Templates/Doccure/img/users/user-sm-2.jpg" | "/Templates/Doccure/img/users/user-sm-3.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Grace Morgan" | "Chloe Anderson" | "Grace Lewis" */
    a1Text: ReactNode;
    /** Detected variants: "15, Sep 2026" | "19, Sep 2026" | "20, Sep 2026" */
    div1Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6 col-sm-12" */
    className?: string;
    /** Detected variants: "blog-item-sixteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-tag" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "blog-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid blog-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-info" */
    div0ClassName3?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "desc" */
    p0ClassName?: string;
    /** Detected variants: "blog-author" */
    div1ClassName2?: string;
    /** Detected variants: "author-img" */
    a0ClassName2?: string;
    /** Detected variants: "#" */
    a0Href2?: string;
    /** Detected variants: "users" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "author-name" */
    a1ClassName?: string;
    /** Detected variants: "#" */
    a1Href?: string;
    /** Detected variants: "author" */
    div0ClassName4?: string;
    /** Detected variants: "blog-date" */
    div1ClassName3?: string;
};
export type HomeSixteenBlogSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection4612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection4612sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Div1Div0A0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection4612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Resources & Blog" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Explore Our Latest Health" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Tips and Articles" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    blogSection4612s: BlogSection4612sItem[];
    blogSection4612sItemWrapper?: (item: BlogSection4612sItem, content: ReactNode) => ReactNode;
    blogSection4612sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection4612sImageVisible?: boolean;
    blogSection4612sImageRenderer?: (item: BlogSection4612sItem, defaultNode: ReactNode) => ReactNode;
    blogSection4612sH3Visible?: boolean;
    blogSection4612sH3Renderer?: (item: BlogSection4612sItem, defaultNode: ReactNode) => ReactNode;
    blogSection4612sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection4612sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection4612sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection4612sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixteenBlogSectionGenerated: FC<HomeSixteenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Resources & Blog",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Explore Our Latest Health",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Tips and Articles",
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1Div1Div0A0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    blogSection4612s,
    blogSection4612sItemWrapper,
    blogSection4612sRenderer,
    blogSection4612sImageVisible,
    blogSection4612sImageRenderer,
    blogSection4612sH3Visible,
    blogSection4612sH3Renderer,
    blogSection4612sImageProps,
    blogSection4612sH3Props,
}) => {
    return (
        <section className="section blog-section-sixteen">
            <div className="container">
                <div className="section-header-sixteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center row-gap-4 blog-row-sixteen"}>
                    {renderCollectionNode(
                        blogSection4612s,
                        (item: BlogSection4612sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6 col-sm-12"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-sixteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "blog-overlay"}>
                                        <a href={item.href ?? "#"} className={item.a0ClassName ?? "blog-tag"}>{item.a0Text}</a>
                                        {renderItemNode(blogSection4612sImageVisible, blogSection4612sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "blog"} className={item.imageWithBasePath0ClassName ?? "img-fluid blog-img"} {...(typeof blogSection4612sImageProps === "function" ? blogSection4612sImageProps(item) : (blogSection4612sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName3 ?? "blog-info"}>
                                            {renderItemNode(blogSection4612sH3Visible, blogSection4612sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection4612sH3Props === "function" ? blogSection4612sH3Props(item) : (blogSection4612sH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>
                                                    <a href={item.a0Href ?? "#"}>{item.a0A0Text}</a>
                                                </h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "desc"}>{item.p0Text}</p>
                                        </div>
                                        <div className={item.div1ClassName2 ?? "blog-author"}>
                                            <div className={item.div0ClassName4 ?? "author"}>
                                                <a href={item.a0Href2 ?? "#"} className={item.a0ClassName2 ?? "author-img"}>
                                                    {renderItemNode(blogSection4612sImageVisible, blogSection4612sImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "users"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-one"} {...(typeof blogSection4612sImageProps === "function" ? blogSection4612sImageProps(item) : (blogSection4612sImageProps ?? {}))} {...(typeof divDiv0Div1Div1Div0A0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div1Div0A0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div1Div0A0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </a>
                                                <a href={item.a1Href ?? "#"} className={item.a1ClassName ?? "author-name"}>{item.a1Text}</a>
                                            </div>
                                            <div className={item.div1ClassName3 ?? "blog-date"}>{item.div1Text}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection4612sItemWrapper,
                        blogSection4612sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeSixteenBlogSectionGenerated;
